import { switchToKeyboard } from '@alfa-bank/site-helpers-common/browser/keyboard-switcher';
import { httpClient } from '@alfa-bank/site-http-client';
import type { Dispatch, FocusEvent, SetStateAction } from 'react';

import * as config from './config';

export interface IEmailFieldHandler {
    callback: ((obj: IInputProps) => void) | undefined;
    setOptions: Dispatch<SetStateAction<IEmailSuggestionsData[]>>;
    setValue: Dispatch<SetStateAction<string>>;
}

export interface IInputProps {
    event: FocusEvent<HTMLElement>;
    name: string;
    value: string;
}

export interface IAxiosResponseData {
    value: string;
}

export interface IEmailSuggestionsData {
    id: string;
    label: string;
}

export const formatEmail: (value: string) => string = value =>
    switchToKeyboard(value, 'en').toLowerCase().trim();

export const getEmailSuggestions: (
    value: string
) => Promise<IEmailSuggestionsData[]> = async value => {
    if (!value.includes('@')) return [];
    const { headers, ref, url } = config;
    const options: RequestInit = {
        headers,
    };

    const { data } = await httpClient.post<IAxiosResponseData[]>(
        `${url}`,
        `_ref=${ref}&value=${value}`,
        options
    );

    return data.map(({ value: val }) => ({
        id: val,
        label: val,
    }));
};
